'use client';

import { useTranslations } from 'next-intl';

import { type ISuggestionItem } from '@/apis/search';

import HighlightFragment from './highlight-fragment';

interface ITitleListProps {
    loading: boolean;
    keyword: string;
    titleList: ISuggestionItem[];
    onSelectTitle: (item: ISuggestionItem) => void;
}

export default function TitleList(props: ITitleListProps) {
    const { loading, titleList, onSelectTitle } = props;
    const t = useTranslations('Discover');

    if (loading) {
        return <div className='text-[12px] leading-[16px] text-[#888]'>{t('search_searching')}</div>;
    }
    if (titleList.length === 0) {
        return (
            <div className='flex justify-center pt-[40px] text-center text-[14px] leading-[20px] text-[#888]'>
                {t('search_no_result')}
            </div>
        );
    }

    return (
        <div>
            {titleList.map(item => (
                <button
                    key={item.title}
                    type='button'
                    className='flex w-full items-center justify-between py-[12px] text-left'
                    onClick={() => onSelectTitle(item)}
                >
                    <span className='font-poppins-medium text-[14px] leading-[20px] text-black'>
                        <HighlightFragment fragment={item.highlight_title_fragment} fallback={item.title} />
                    </span>
                </button>
            ))}
        </div>
    );
}
